export default __webpack_public_path__ + "static/media/circle.725cca42.png";